export const productInfoFields = [
  { label: "ID", key: "row_id.value" },
  {
    label: "Nama Produk", key: "name.value", isSortable: true,
  },
  {
    label: "Jenis Produk", key: "product_type_name.value", isSortable: true,
  },
  {
    label: "SKU", key: "sku.value", isSortable: true,
  },
  {
    label: "Deskripsi", key: "description.value", isSortable: true,
  },
  {
    label: "Satuan Dasar", key: "uom.value", isSortable: true,
  },
  { label: "Berat Produk", key: "weight.value", type: 'number', },
  { label: "Volume Produk", key: "volume.value", type: 'number', },
  { label: "Harga Standar Produk (Rp)", key: "price.value", type: 'number', }
].map((field) => ({
  ...field,
  showErrorKey: field.key.replace('.value', ''),
  thAttr: {
    style: 'min-width:180px',
  },
}));

export const conversionFields = [
  { label: "ID", key: "row_id.value" },
  { label: "Jumlah", key: "amount_one.value" },
  {
    label: "(Dari) Satuan Konversi", key: "name.value", isSortable: true,
  },
  {
    label: "Sama Dengan", key: "equal.value",
  },
  { label: "Jumlah", key: "amount.value", type: 'number', },
  {
    label: "(Ke) Satuan Dasar", key: "uom.value", isSortable: true,
  },
  { label: "Berat Konversi", key: "weight.value", type: 'number', },
  { label: "Volume Konversi", key: "volume.value", type: 'number', },
  { label: "Harga Konversi (Rp)", key: "price.value", type: 'number', }
].map((field) => ({
  ...field,
  showErrorKey: field.key.replace('.value', ''),
  thAttr: {
    style: 'min-width:180px;',
  },
}));
